module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray pb-fixed-btn"
  }, [_c('backTitleBar'), _vm._v(" "), _c('div', {
    staticClass: "pd-025 mt-20"
  }, [_c('div', {
    staticClass: "product-list bg-fff"
  }, [_vm._l((_vm.entity.productList), function(prod, prodIndex) {
    return _c('div', {
      key: prodIndex,
      staticClass: "product-item"
    }, [_c('div', {
      staticClass: "flex pd-250"
    }, [_c('div', {
      staticClass: "product-img"
    }, [_c('img', {
      attrs: {
        "src": prod.imgPathView,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "product-info flex1 ofh"
    }, [_c('div', {
      staticClass: "fs-28 color-000 name"
    }, [_vm._v(_vm._s(prod.productName))]), _vm._v(" "), _c('div', {
      staticClass: "mt-15 fs-28 color-999"
    }, [_vm._v("规格：" + _vm._s(prod.specName))]), _vm._v(" "), _c('div', {
      staticClass: "flex-between fs-28 color-999"
    }, [_c('div', [_vm._v("销售价：¥" + _vm._s(prod.salePrice))]), _vm._v(" "), _c('div', [_vm._v("x" + _vm._s(prod.productQty))])])])])])
  }), _vm._v(" "), (_vm.entity.orderMessage) ? _c('div', {
    staticClass: "flex pd-250 fs-28 bd-top"
  }, [_c('div', {
    staticClass: "color-999"
  }, [_vm._v("留言")]), _vm._v(" "), _c('div', {
    staticClass: "color-333 ml-20"
  }, [_vm._v(_vm._s(_vm.entity.orderMessage))])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "card mt-20 mr-25 ml-25 pd-025"
  }, [_c('div', {
    staticClass: "input-field bd-bot click",
    on: {
      "click": function($event) {
        _vm.showPop = true;
      }
    }
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("配送快递")]), _vm._v(" "), _c('div', {
    staticClass: "field-content",
    class: _vm.formItem.expressName ? 'color-333' : 'color-999'
  }, [_vm._v(_vm._s(_vm.formItem.expressName || '请选择配送快递'))]), _vm._v(" "), _c('div', {
    staticClass: "alifont icon-fanhui1 fs-30 color-999 right"
  })]), _vm._v(" "), (_vm.formItem.expressType !== 'ziying') ? _c('div', {
    staticClass: "input-field"
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("快递单号")]), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "clearable": true,
      "placeholder": "请输入快递单号"
    },
    model: {
      value: (_vm.formItem.waybillNo),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "waybillNo", $$v)
      },
      expression: "formItem.waybillNo"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "fixed-bot"
  }, [_c('div', {
    staticClass: "btn click",
    on: {
      "click": function($event) {
        return _vm.send()
      }
    }
  }, [_vm._v("确认发货")])]), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showPop),
      callback: function($$v) {
        _vm.showPop = $$v
      },
      expression: "showPop"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.dicts['express_type'],
      "value-key": "codename"
    },
    on: {
      "cancel": function($event) {
        _vm.showPop = false
      },
      "confirm": _vm.onConfirm
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa447848","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/order/sendOrder.vue
// module id = TcBW
// module chunks = 51